export default "__VITE_ASSET__3kG$2h7Q__"